import {
  GET_USER_PACKAGE_REQUEST,
  GET_USER_PACKAGE_SUCCESS,
  GET_USER_PACKAGE_FAILURE,
} from '../actions/userActions';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export default function userPackage(state = initialState, action) {
  switch (action.type) {
    case GET_USER_PACKAGE_REQUEST:
      return { loading: true, error: null, data: null };
    case GET_USER_PACKAGE_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case GET_USER_PACKAGE_FAILURE:
      return { loading: false, error: action.error || 'Failed to fetch user package', data: null };
    default:
      return state;
  }
}


